<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  isOpen: { type: Boolean, required: true },
  title: { type: String, required: true },
  message: { type: String, required: true },
  buttonYes: { type: String, default: 'Sim' },
  buttonNo: { type: String, default: 'Não' }
})

const emit = defineEmits(['confirm', 'cancel', 'update:isOpen'])

const show = ref(false)

// Sincroniza prop -> local
watch(() => props.isOpen, (val) => {
  show.value = val
}, { immediate: true })

// Sincroniza local -> prop (apenas quando o Vuetify fecha nativamente, ex: clique fora)
watch(show, (val) => {
  if (!val && props.isOpen) {
    emit('update:isOpen', false)
  }
})

const onConfirm = () => {
  // Não precisamos mudar show.value aqui, deixamos o pai destruir o componente
  emit('confirm')
}

const onCancel = () => {
  emit('cancel')
}
</script>

<template>
  <v-dialog
      v-model="show"
      max-width="400"
      @keydown.esc="onCancel"
      @click:outside="onCancel"
  >
    <v-card>
      <v-card-title class="text-h6"> <v-icon color="error" class="mr-2">mdi-help-circle-outline</v-icon>
        {{ title }}
      </v-card-title>

      <v-card-text class="pt-4 body-1">
        {{ message }}
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
            color="grey darken-1"
            text
            @click="onCancel"
        >
          {{ buttonNo }}
        </v-btn>

        <v-btn
            color="error"
            depressed
            @click="onConfirm"
        >
          {{ buttonYes }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>